import React from 'react'
import Flex from 'typescript-styled-flex'
import { formValueSelector } from 'redux-form'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { theme } from '../../../../theme'
import HeaderBadge from '../../../../components/Calendar/ReservationModal/HeaderBadge'
import { is } from '../../../../components/MediaQuery'
import {
  getCreateReservationModalRoom,
  getCreateReservationModalStatus,
  getUpdateReservationModalRoom,
  getUpdateReservationModalStatus,
} from '../../../../reducers/bookingCalendar/selectors/reservationForm'
import useSize from '../../../../hooks/useSize'

function Badges({ room, customColor, setCustomColor, status }) {
  const isDesktop = is.desktop()
  const size = useSize()
  const { t } = useTranslation()

  return (
    <Flex
      alignStart={true}
      wrap={!isDesktop}
      style={{ marginLeft: `${-20 * size}px`, minWidth: '0' }}
    >
      {room && (
        <HeaderBadge
          size={size}
          color={theme.colors.palette.slateGrey}
          style={{ marginLeft: `${20 * size}px` }}
          bgcolor={theme.colors.palette.paleGrey}
        >
          {room.name}
        </HeaderBadge>
      )}
      <HeaderBadge
        size={size}
        style={{ marginLeft: `${20 * size}px` }}
        bgcolor={customColor && setCustomColor ? customColor : status.color}
        color={'white'}
      >
        {t(status.label)}
      </HeaderBadge>
    </Flex>
  )
}

const mapStateToPropsCreate = (state) => {
  const selector = formValueSelector('create_reservation')
  return {
    customColor: selector(state, 'customColor'),
    room: getCreateReservationModalRoom(state),
    setCustomColor: selector(state, 'setCustomColor'),
    status: getCreateReservationModalStatus(state),
  }
}

const mapStateToPropsUpdate = (state) => {
  const selector = formValueSelector('update_reservation')
  return {
    customColor: selector(state, 'customColor'),
    room: getUpdateReservationModalRoom(state),
    setCustomColor: selector(state, 'setCustomColor'),
    status: getUpdateReservationModalStatus(state),
  }
}

export default {
  Create: connect(mapStateToPropsCreate)(Badges),
  Update: connect(mapStateToPropsUpdate)(Badges),
}
